import React, { useEffect, useState } from 'react'
import {
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Snackbar,
  SnackbarContent,
} from '@material-ui/core'
import styled from 'styled-components'
import {useParams, useLocation, useHistory} from 'react-router-dom'
import Cookies from 'js-cookie'
import { RiImageEditFill } from 'react-icons/ri'
import UploadForm from './UploadForm'

import '../../assets/styles.css'

const base_url = 'https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm'

export default function EditSalesPerson() {
  const location = useLocation()
  const history = useHistory()
  const {salespersonID} = location.state
  const token = Cookies.get('token')
  const [salesperson, setSalesperson] = useState(null)
  const [salesImg, setSalesImg] = useState(null)
  const [uuid, setUUID] = useState(null)
  const [locationsList, setLocationsList] = useState(null)
  const [snackbar, setSnackbar] = useState(null)

  const getSalesPerson = () => {
    const request = fetch(`${base_url}/salesperson/id/${salespersonID}`, {
      headers: {
        'token': token
      }
    })

    request.then(response => response.json())
    .then(data => {
      console.log(data)
      setSalesperson(data[0])
      setSalesImg(data[0].ImgPath)
      setUUID(data[0].UUID)
    })
    .catch(error => console.log(error))
  }

  const getLocations = () => {
    const request = fetch(`${base_url}/salesperson/locations`, {
      headers: {
        token: token
      }
    })

    request.then(response => response.json())
    .then(data => setLocationsList(data))
    .catch(error => console.log(error))
  }

  useEffect(() => getSalesPerson(), [])
  useEffect(() => getLocations(), [])

  const getUUID = (img) => {
    if(img) {
      const fd = new FormData()
      fd.append('imgPath', img, img.name)

      const request = fetch(`${base_url}/salesperson/uploadImage`, {
        method: "POST",
        headers: {
          'Access-Control-Allow-Origin': "*",
          'token': token
        },
        body: fd
      })
      .then(response => {
        if(response.ok === true) {
          return response.json()
        }
      })
      .then(data => {
        setUUID(data.uuid)
      })
    }
  }

  const handleSnackbarClose = () => {
    setSnackbar(null)
  }

  const handlePhotoSelect = (e) => {
    const {files} = e.target

    setSalesImg(URL.createObjectURL(files[0]))
    getUUID(files[0])
  }

  const handleSubmit = (salesPersonObj) => {
    const { first, last, locationID, Inclusion } = salesPersonObj

    console.log(salesImg)
    console.log(uuid)

    const pending = {
      'locationID': locationID,
      'imgPath': salesImg,
      'lastName': last,
      'firstName': first,
      'uuid': uuid,
      'inclusionStatus': Inclusion,
    }

    console.log(pending)

    const request = fetch(`${base_url}/salesperson/update`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'token': token,
      },
      body: JSON.stringify(pending)
    })

    request.then(response => {
      if(response.ok === true) {
        setSnackbar('The information for this sales consultant has been updated')
        setTimeout(() => history.push('/sales-consultants'), 2500)
      } else {
        setSnackbar('Oops! Something went wrong. Please make sure all required fields are filled out correctly')
      }
    })
    .catch(error => console.log(error))
  }

  if(!salesperson || !locationsList) return <CircularProgress />

  return (
    <div className="sales-edit">

      <Snackbar
        open={Boolean(snackbar)}
        autoHideDuration={4500}
        onClose={handleSnackbarClose}
        anchorOrigin={{vertical: 'top', horizontal: 'center'}}
      >
        <SnackbarContent
          message={snackbar}
        />
      </Snackbar>

      <Card className="card">
        {console.log(salesperson)}
        <CardMedia className="media">
          <img src={salesImg} alt="" style={{height: '325px', width: '274px'}}/>
          <form encType='multipart/form-data'>
            <input
              id="contained-button-file"
              name="imgPath"
              accept="image/*"
              type="file"
              onChange={handlePhotoSelect}
              style={{display: 'none'}}
            />
          </form>
          <label htmlFor="contained-button-file">
            <Button
              variant="outlined"
              component="span"
              className="upload-btn"
            >
              <Typography style={{fontSize: '12px'}}>CHANGE PHOTO</Typography>
              <RiImageEditFill style={{marginLeft: '5px', fontSize: '11px'}}/>
            </Button>
          </label>
        </CardMedia>
        <CardContent style={{width: "100%"}}>
          <UploadForm
            firstName={salesperson.FirstName}
            lastName={salesperson.LastName}
            address={salesperson.Address1}
            address2={salesperson.Address2}
            city={salesperson.City}
            state={salesperson.State}
            zip={salesperson.ZIP}
            inclusion={salesperson.InclusionStatus}
            submit={handleSubmit}
            locationsList={locationsList}
          />
        </CardContent>
      </Card>
    </div>
  )
}
